import React, { FC, useState } from 'react'
import Analytics from '@lib/Analytics'
import { Expander } from '@components/Expander'
import { FaqDescription } from './FaqDescription'
import {
  FaqSectionWrapper,
  InnerContent,
  Title,
  FaqList,
  FaqListItem,
  FaqTitle,
} from './FaqSection.elements'

export type FaqItemType = {
  title: string
  text: string
}

type Props = {
  title: string
  faqs: FaqItemType[]
}

export const FaqSection: FC<Props> = ({ faqs, title }) => {
  const [openedFaqs, setOpenedFaqs] = useState<Record<number, boolean>>({})

  const handleFaqToggle = (index: number) => () => {
    const prevValue = openedFaqs[index]
    Analytics.log('Toggle', { location: 'faq', state: !prevValue ? 'open' : 'close' })
    setOpenedFaqs({
      ...openedFaqs,
      [index]: !prevValue
    })
  }

  return (
    <FaqSectionWrapper>
      <InnerContent>
        <Title>{title}</Title>

        <FaqList>
          {faqs.map((faq, index) => (
            <li key={`faq-item-${index}`}>
              <FaqListItem>
                <Expander
                  isOpen={!!openedFaqs[index]}
                  expandedContent={(
                    <FaqDescription
                      faq={faq}
                      onToggle={handleFaqToggle(index)}
                      isOpen={!!openedFaqs[index]}
                    />
                  )}
                  onToggle={handleFaqToggle(index)}
                  usePlusIcon
                >
                  <FaqTitle>
                    {faq.title}
                  </FaqTitle>
                </Expander>
              </FaqListItem>
            </li>
          ))}
        </FaqList>
      </InnerContent>
    </FaqSectionWrapper>
  )
}
